import React from 'react'
import Vars from 'Consts/vars'
import { truncate_text } from 'Helpers/utils'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'

const TypeOne = (props) => (
  <div className={`article-card-desktop-${props.type} ${props.size || 'big'}`}>
    <a href={props.article.url} className="article-image">
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <ImageFallback
          src={props.article.image}
          alt={props.article.title}
          objectFit="cover"
          layout="fill"
          priority
          quality={80}
          fallbackSrc={Vars.imageBrokenDefault.rectangle}
        />
      </div>
      {props.is_sponsored && (
        <p className="article-text-sponsored">Sponsored</p>
      )}
    </a>
    <div className="article-content">
      <p className="article-category">
        {truncate_text(props.article.category.name, 26)}
        {props.is_sponsored && (
          <span className="article-text-sponsored-dash">SPONSORED</span>
        )}
      </p>
      <a className="article-title" href={props.article.url}>
        {props.article.title}
      </a>
    </div>
    <style jsx>
      {`
        .article-card-desktop-${props.type} {
          display: flex;
          flex-flow: column;
          border: none;
          word-break: break-word;
          width: 100%;
        }
        .article-card-desktop-${props.type} {
          position: relative;
          word-break: break-word;
        }
        .article-card-desktop-${props.type} .article-image {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
          flex-shrink: 0;
        }
        .article-card-desktop-${props.type} .article-image {
          height: ${props.height_img_small ? props.height_img_small : `178px`};
        }
        .article-card-desktop-${props.type}.big .article-image {
          height: ${props.height_img_small ? props.height_img_small : `433px`};
        }
        .article-card-desktop-${props.type} .article-image:hover {
          ${Vars.HOVER_TYPE.IMAGE}
        }
        .article-card-desktop-${props.type}
          .article-image
          .article-image-source {
          width: 100%;
          min-height: 100%;
          object-fit: cover;
        }
        .article-card-desktop-${props.type}.big .article-content {
          display: flex;
          justify-content: center;
          flex-direction: column;
          position: absolute;
          right: 0;
          width: 290px;
          backdrop-filter: blur(7px);
          height: ${props.height_img_small ? props.height_img_small : `433px`};
          padding: 10px 15px;
        }

        .article-card-desktop-${props.type}.big .article-content::before {
          content: '';
          background: #000000;
          position: absolute;
          top: 0px;
          right: 0px;
          bottom: 0px;
          left: 0px;
          opacity: 0.75;
        }

        .article-card-desktop-${props.type} .article-content .article-title {
          font-family: ${props.font_title};
          font-weight: 600;
          font-size: 20px;
          color: #000;
          line-height: 1.5;
          margin-bottom: 0;
          z-index: 99;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .article-card-desktop-${props.type}.big
          .article-content
          .article-title {
          color: #fff;
        }
        .article-card-desktop-${props.type}
          .article-content
          .article-title:hover {
          ${Vars.HOVER_TYPE.TEXT_PINK}
        }
        .article-card-desktop-${props.type} .article-content .article-category {
          font-family: Roboto, sans-serif;
          font-size: 12px;
          font-weight: 400;
          line-height: 1;
          color: #db284e;
          text-transform: uppercase;
          margin: 20px 0;
          z-index: 99;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .article-card-desktop-${props.type}
          .article-content
          .article-category
          span.article-text-sponsored-dash {
          color: #919eab;
          position: relative;
          margin-left: 45px;
        }
        .article-card-desktop-${props.type}
          .article-content
          .article-category
          span.article-text-sponsored-dash::before {
          position: absolute;
          content: '';
          width: 20px;
          height: 1px;
          background: #919eab;
          top: 50%;
          left: -30px;
        }
        .article-card-desktop-${props.type}.big
          .article-content
          .article-category {
          color: #fff;
        }
        .article-card-desktop-${props.type}
          .article-image
          .article-text-sponsored {
          position: absolute;
          top: 8px;
          left: 8px;
          margin: 0;
          padding: 4px 8px;
          background-color: #ffffff;
          border-radius: 18px;
          color: #db284e;
          font-family: Roboto;
          font-size: 8px;
          font-style: normal;
          font-weight: 500;
          line-height: 10px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
      `}
    </style>
  </div>
)

export default TypeOne
